import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import logo from '../../assets/duomo.svg';

import './Footer.css';

/* eslint-disable jsx-a11y/anchor-has-content */
const Footer = ({ className }) => (
  <footer className={className}>
    <div className="contact-us">
      <h6>Contact Duomo</h6>
      <p>
        2 Angel Square, London,<br/>
        EC1V 1NY
      </p>
      <p><a href="tel:03300889659">0330 088 9659</a></p>
    </div>
    <div>
      <a className="footer-social-link" href="https://twitter.com/DuomoHQ" target="_blank" rel="noopener noreferrer"><i className="ion-social-twitter-outline" aria-hidden="true" title="Twitter"></i></a>
      <a className="footer-social-link" href="https://www.facebook.com/DuomoHQ" target="_blank" rel="noopener noreferrer"><i className="ion-social-facebook-outline" aria-hidden="true" title="Facebook"></i></a>
      <a className="footer-social-link" href="mailto:hello@duomohq.com" target="_blank" rel="noopener noreferrer"><i className="ion-ios-email-outline" aria-hidden="true" title="Email"></i></a>
    </div>
    <a href="https://www.duomohq.com/">
		  <p>Copyright 2017 &copy; <img src={logo} alt='Duomo Logo' /><span className="duomo">Duomo</span>. All Rights Reserved</p>
    </a>
    <div className="footer-links">
      <Link to="/cookie-policy">Cookie Policy</Link>&nbsp;|&nbsp;
      <Link to="/terms">Terms &amp; Conditions</Link>&nbsp;|&nbsp;
      <Link to="/privacy">Privacy Policy</Link>&nbsp;|&nbsp;
      <Link to="/acceptable-use">Acceptable Use Policy</Link>
    </div>
  </footer>
);
/* eslint-enable jsx-a11y/anchor-has-content */

Footer.propTypes = {
  className: PropTypes.string.isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx